// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PromoRoll_wrapper__9Vk5Y","content":"PromoRoll_content__DOoXQ","promo":"PromoRoll_promo__Fh261","slider-controls":"PromoRoll_slider-controls__dmNiQ"};